module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.badges.length) ? _c('ul', {
    staticClass: "badges"
  }, _vm._l((_vm.badges), function(ref, index) {
    var title = ref.title;
    var mod = ref.mod;

    return _c('li', {
      key: index,
      staticClass: "badges__badge",
      class: [("badges__badge_" + mod), {
        current: _vm.curr === index
      }]
    }, [_vm._v(_vm._s(title))])
  }), 0) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e1a32ad4","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/uikit/components/ListCardBadge/ListCardBadge.vue
// module id = 2812883473062bc6852d
// module chunks = 89